require('./src/styles/fonts/inter.css');
require('./src/styles/global.css');
require('./src/styles/page.css');
require('./src/styles/prism.css');

exports.onInitialClientRender = () => {
  // Clock that analytics `seconds` properties are measured against. Reset on
  // every route change below, so an SPA navigation is timed from the new page
  // rather than from the original page load. See src/utils/track.js.
  window.polypaneRouteStart = Date.now();
  window.addEventListener('scroll', loadDriftWidgetOnActivity);
};

exports.onRouteUpdate = ({ prevLocation }) => {
  document.body.style.overflow = null;
  window.polypaneRouteStart = Date.now();
  if (prevLocation && loadDriftWidgetOnActivity) {
    loadDriftWidgetOnActivity();
  }
};
